import { CENTER_OF_EXCELLENCE, NeurodiversitySearcherType, TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC } from './types'
import { TOOLKIT_TYPE } from '../wellnessToolkit/types'

export const isToolkitTypeCenterOfExcellence = (
  toolkit?: TOOLKIT_TYPE | string,
  toolkitSubTopic?: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC | string,
): boolean => {
  return (
    Boolean(toolkit) &&
    Boolean(toolkitSubTopic) &&
    Object.values(CENTER_OF_EXCELLENCE).includes(toolkit as CENTER_OF_EXCELLENCE) &&
    Object.values(TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC).includes(
      toolkitSubTopic as TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC,
    )
  )
}

export const isToolkitTypeNeurodiversity = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.NEURODIVERSITY
}

export const isToolkitTypeHealthChallenges = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.HEALTH_CHALLENGES
}

export const isToolkitTypeWomensHealth = (toolkit?: TOOLKIT_TYPE) => {
  return toolkit && toolkit === CENTER_OF_EXCELLENCE.WOMENS_HEALTH
}

/**
 * Determine what kind of searcherType neurodiversity page should show
 * @param isUserTeen
 * @param shouldHideChildSearchCTA
 */
export const getDefaultNeurodiversitySearcherType = (isUserTeen: boolean, shouldHideChildSearchCTA: boolean) => {
  if (isUserTeen) {
    return NeurodiversitySearcherType.TEEN
  }
  return shouldHideChildSearchCTA ? NeurodiversitySearcherType.ADULT : NeurodiversitySearcherType.CHILD
}

export const getToolkitSubTopicLabel = (toolkitSubTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => {
  switch (toolkitSubTopic) {
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION:
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION_CHILD:
      return 'Neuropsychological evaluation'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_CAREGIVER_TRAINING_FOR_NEURODIVERSE_CHILD:
      return 'Caregiver training'
    case TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC.NEURODIVERSITY_TREATMENT_FOR_AUTISM_CHILD:
      return 'Support for ASD'
    default:
      return toolkitSubTopic
  }
}
